import React, { ReactElement } from 'react';
import AddPripomienkaComponent from './component/AddPripomienkaComponent';
import ClassType from '../../model/pripomienka/ClassType';

interface Props {
  classType: ClassType;
}
const AddPripomienka = ({
  classType,
}: Props): ReactElement => (
  <AddPripomienkaComponent
    classType={classType}
  />
);

export default AddPripomienka;
